export enum PickingListReTransportStatus {
    WaitingConfirm = 1,
    Confirmed = 2,
    Success = 3,
    Reject = -1
}
